module.exports = __webpack_public_path__ + "img/ze.799e5756.jpg";